<template>
  <card-item
    card="item_timetable"
    :tabs="tabs"
    :activeTab="activeTab"
    @setTab="setTab"
    :id="id"
    :isFull="true"
    :infoKeys="infoKeys"
  >
  </card-item>
</template>
<script>
export default {
  props: {},
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          title: "Журнал",
          key: "journal",
          component: () => import("./Info"),
        },
        {
          title: "Урок",
          key: "lesson_fdf",
          component: () => import("./Doc"),
        },
        {
          key: "tasks",
          title: "Задания",
          component: () => import("./Work"),
        },
        {
          key: "homework",
          title: "Домашние задания",
          component: () => import("./Homework"),
        },
        {
          key: "additional_material",
          title: "Доп. материалы",
          component: () => import("./Media"),
        },
        // {
        //   key: "additional_material",
        //   title: "Авторы тем",
        //   component: () => import("./Authors"),
        // },
        {
          key: "additional_material",
          title: "Учебные материалы",
          component: () => import("./Lessonplans"),
        },
      ],
      activeTab: 0,
      infoKeys: [
        {
          key: "title",
          object: "group",
          title: "Класс",
        },
        {
          key: "position",
          object: "schedule",
          title: "Номер урока",
        },
        {
          key: "title",
          object: "lessonplan",
          title: "Плановый урок",
        },
        {
          key: "title",
          object: "discipline",
          title: "Предмет",
        },
        {
          key: "date",
          title: "Дата",
          dateFormat: true,
        },
        {
          key: "locale",
          object: "group",
          title: "Локализация класса",
        },
      ],
    };
  },
  methods: {
    setTab(val) {
      this.activeTab = val;
    },
  },
};
</script>